import {GlobalApplicationState} from '~/redux/reducers/RootReducer';
import {UserFeedbackState} from '~/redux/reducers/UserFeedbackReducer';

export const selectUserFeedback = ({userFeedback}: GlobalApplicationState): UserFeedbackState =>
    userFeedback;
